import React, {
  useEffect,
  useState,
  useRef,
  useCallback,
  useMemo,
  useContext,
} from "react";
import axios from "axios";
import { useParams, Link } from "react-router-dom";
import Select from "react-select";
import config from "../../../config/config";
import Loader from "../../../components/Loader/Loader";
import Sidebar from "../../Dashboard/Sidebar/Sidebar";
import JsBarcode from "jsbarcode";
import moment from "moment";
import ReportDate from "../../../components/Reports/ReportDate";
import "ag-grid-enterprise";
import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-alpine.css";
import "../../../assets/css/customersummary.css";
import "jspdf-autotable";
import Moment from "moment";
import { CUSTOM_SELECT_DROPDOWN_STYLE } from "../../../common/Constant";
import CommonMatrialReactTable from "../../../components/Datatable/CommonMatrialReactTable";
import CurrencySymbols from "../../../common/CurrencySymbol";
import { AppContext } from "../../../context/AppContext";
import { toastWarn } from "../../../common/Toast";

const InventoryDetailedReport = (props) => {
  const locationid = localStorage.getItem("Location");
  const token = localStorage.getItem("Token");
  const { CurrencySymbol, FractionDigits, dateFormate } =
    useContext(AppContext);
  const [responseData, setResponseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [startdate, setStartDate] = useState("");
  const [enddate, setEndDate] = useState("");
  const [selectedDate, setSelectedDate] = useState([]);
  const [selectReport, setSelectReport] = useState(7);
  const [isChecked, setIsChecked] = useState(0);
  const [locationdropdown, setLocationDropdown] = useState([]);
  const [selectedlocationid, setSelectedLocationID] = useState(
    Number(locationid)
  );
  const [totalData, setTotalData] = useState(0);

  const handleDropdownChange = (event) => {
    setSelectReport(event?.value);
    if (event?.value == 1) {
      setStartDate("");
      setEndDate("");
    }
  };
  const handleLocationDropdownChange = (event) => {
    setSelectedLocationID(event?.value);
    console.log(event?.value, "Location chnage");
  };
  const handleCheckBoxChnage = (e) => {
    console.log(e.target.checked, "checkevent");
    let checked = e.target.checked === true ? 1 : 0;
    setIsChecked(checked);
  };

  const handleNavigation = (Id, Type) => {
    if (Type === "Sale") {
      window.open(`/sales-receipt/${Id}`, "_blank");
    } else if (Type === "Receicing") {
      window.open(`/receiving-receipt/${Id}`, "_blank");
    }
  };

  const apicall = () => {
    setLoading(true);
    axios
      .get(
        `${config.reportsBaseUrl}/reports/inventorydetailedreport?filtercolumnsearchtext=&currentorder=&ordercolumn=&pagesize=0&pagenumber=0&filtertext=&startdate=${startdate}&enddate=${enddate}&locationid=${selectedlocationid}&ischecked=${isChecked}&currentlocationid=${locationid}
            `,
        {
          headers: {
            "Content-Type": "application/json;charset=UTF-8",
            "Access-Control-Allow-Origin": "*",
            Authorization: token,
          },
        }
      )

      .then((res) => {
        if (res.data.ResponseCode === "SUCCESS") {
          setResponseData(res.data.ResponseData);
          if (res.data.ResponseData.length > 0) {
            setTotalData(res.data.ResponseData[0].AverageQuantitySold);
            // setTotalData({
            //   ...totalData,
            //   TotalSum: res.data.ResponseData[0].TotalSum,
            //   SubTotalSum: res.data.ResponseData[0].SubTotalSum,
            //   TaxSum: res.data.ResponseData[0].TaxSum,
            //   CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
            //   ProfitSum: res.data.ResponseData[0].ProfitSum,
            // });
          } else {
            toastWarn("No Records Found!");
            setTotalData(0);
            // setTotalData({
            //   ...totalData,
            //   TotalSum: 0,
            //   SubTotalSum: 0,
            //   TaxSum: 0,
            //   CostOfGoodsSoldSum: 0,
            //   ProfitSum: 0,
            // });
          }
          setLoading(false);
        }
      })
      .catch((err) => {
        console.log(err);
        setLoading(false);
        return;
      });
  };

  // useEffect(() => {
  //   const columnIndex = sorting.length > 0 ? sorting[0]?.id : "";
  //   console.log(
  //     JSON.stringify(columnFilters) + " columnFilters | ",
  //     globalFilter + " globalFilter | ",
  //     pagination.pageIndex + " pagination.pageIndex | ",
  //     pagination.pageSize + " pagination.pageSize | ",
  //     columnIndex,
  //     sorting[0]?.id,
  //     sorting[0]?.desc === undefined
  //       ? "desc"
  //       : (sorting[0]?.desc === true ? "desc" : "asc") + " sorting | ",
  //     startdate + " startdate | ",
  //     enddate + " enddate",
  //     locationid + " locationid",

  //     "api Call payload"
  //   );

  //   const FilterColumnText = {};
  //   FilterColumnText.filtercolumntext = columnFilters.map((el, index) => {
  //     return { columnname: el.id, value: el.value, id: index + 1 };
  //   });

  //   let FilterColumnSearchText = JSON.stringify(FilterColumnText);

  //   axios
  //     .get(
  //       `${
  //         config.reportsBaseUrl
  //       }/reports/inventorydetailedreport?filtercolumnsearchtext=${FilterColumnSearchText}&currentorder=${
  //         sorting[0]?.desc === undefined
  //           ? "desc"
  //           : sorting[0]?.desc === true
  //           ? "desc"
  //           : "asc"
  //       }&ordercolumn=${columnIndex}&pagesize=${
  //         pagination.pageSize
  //       }&pagenumber=${pagination.pageIndex + 1}&filtertext=${
  //         globalFilter === undefined ? "" : globalFilter
  //       }&startdate=${startdate}&enddate=${enddate}&locationid=${locationid}
  //           `,
  //       {
  //         headers: {
  //           "Content-Type": "application/json;charset=UTF-8",
  //           "Access-Control-Allow-Origin": "*",
  //           Authorization: token,
  //         },
  //       }
  //     )

  //     .then((res) => {
  //       console.log("res======>", res);
  //       console.log(res.data.ResponseData, "res======>");
  //       if (res.data.ResponseCode === "SUCCESS") {
  //         setResponseData(res.data.ResponseData);
  //         if (res.data.ResponseData.length > 0) {
  //           setTotalData({
  //             ...totalData,
  //             TotalSum: res.data.ResponseData[0].TotalSum,
  //             SubTotalSum: res.data.ResponseData[0].SubTotalSum,
  //             TaxSum: res.data.ResponseData[0].TaxSum,
  //             CostOfGoodsSoldSum: res.data.ResponseData[0].CostOfGoodsSoldSum,
  //             ProfitSum: res.data.ResponseData[0].ProfitSum,
  //           });
  //         } else {
  //           setTotalData({
  //             ...totalData,
  //             TotalSum: 0,
  //             SubTotalSum: 0,
  //             TaxSum: 0,
  //             CostOfGoodsSoldSum: 0,
  //             ProfitSum: 0,
  //           });
  //         }
  //       }
  //       setLoading(false);
  //     })
  //     .catch((err) => {
  //       setIsError(true);
  //       console.log(err);
  //       setLoading(false);
  //       return;
  //     });

  //   setIsError(false);
  //   setIsLoading(false);
  //   setIsRefetching(false);
  // }, [
  //   columnFilters,
  //   globalFilter,
  //   pagination.pageIndex,
  //   pagination.pageSize,
  //   sorting,
  //   startdate,
  //   enddate,
  //   locationid,
  // ]);

  useEffect(() => {
    axios
      .get(`${config.reportsBaseUrl}/reports/reportperioddropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        console.log("setSelectedDate======>", res);
        setSelectedDate(res.data.ResponseData);
        return res;
      });

    // Location Dropdown
    axios
      .get(`${config.locationBaseUrl}/locations/locationdropdown`, {
        headers: {
          "Content-Type": "application/json;charset=UTF-8",
          Authorization: token,
        },
      })
      .then((res) => {
        setLocationDropdown(res.data.ResponseData);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  const callback = (payload, enddate2) => {
    console.log("stardate =>", payload);
    setStartDate(payload);
    setEndDate(enddate2);

    console.log("enddate =>", enddate2);
  };

  const columns = useMemo(() => [
    {
      header: "Location",
      accessorKey: "Location",
      filterFn: "contains",
    },
    {
      header: "Item Id",
      accessorKey: "ItemID",
      filterFn: "contains",
    },
    {
      header: "Date",
      accessorKey: "Date",
      filterFn: "contains",
      Cell: ({ row }) =>
        moment(row.original.Date).format("YYYY-MM-DD") === "Invalid date"
          ? ""
          : moment(row.original.Date).format(`${dateFormate.toUpperCase()} hh:mm A`),
    },
    {
      header: "Item Name",
      accessorKey: "ItemName",
      filterFn: "contains",
    },
    {
      header: "Customer",
      accessorKey: "Customer",
      filterFn: "contains",
    },
    {
      header: "Employee",
      accessorKey: "Employee",
      filterFn: "contains",
    },
    {
      header: "Category",
      accessorKey: "Category",
      filterFn: "contains",
    },
    {
      header: "Item Number",
      accessorKey: "ItemNumber",
      filterFn: "contains",
    },
    {
      header: "Product ID",
      accessorKey: "ProductID",
      filterFn: "contains",
    },
    {
      header: "In/OutQty",
      accessorKey: "InOutQty",
      filterFn: "contains",
    },
    {
      header: "Comments",
      accessorKey: "Comments",
      filterFn: "contains",
    },
    // {
    //   header: "Balance",
    //   accessorKey: "Balance",
    //   filterFn: "contains",
    // },
    {
      header: "Type",
      accessorKey: "Type",
      filterFn: "contains",
      Cell: ({ row }) => {
        const type = row?.original?.Type;

        // If the type is "Inventory Import" or "Inventory Quantity Adjustment," display the type as plain text
        if (
          type === "Inventory Import" ||
          type === "Inventory Quantity Adjustment"
        ) {
          return <span>{type}</span>;
        }

        // Otherwise, render the type as a clickable link
        return (
          <Link
            style={{
              borderRadius: "0.3rem",
              color: "#343f62",
              maxWidth: "18ch",
              fontWeight: "600",
              padding: "0.3rem", // Use "padding" instead of shorthand "p" to ensure compatibility
              cursor: "pointer",
              textDecoration: "underline",
            }}
            type="button"
            onClick={() => handleNavigation(row?.original?.PosId, type)}
            data-bs-toggle="modal"
            data-bs-target="#staticBackdrop"
          >
            {type}
          </Link>
        );
      },
    },

    {
      header: "Reference",
      accessorKey: "Reference",
      filterFn: "contains",
    },
  ]);

  let dashStyle = {
    // width: "280px",
    background: "#fff",
    marginTop: "10px",
    borderRadius: "6px",
    padding: "20px",
    border: "1px solid #E8EBED",
  };

  let reportdropdown = [];
  const data2 = selectedDate.map(
    (u, i) => (reportdropdown[i] = { label: u.Name, value: u.ID })
  );

  const locationDropdownOption = [
    { label: "All", value: 0 }, // Adding "All" option
    ...locationdropdown.map((u) => ({ label: u.Name, value: u.Id })),
  ];

  console.log(responseData, "responseData941");
  return (
    <>
      <Loader loading={loading} />
      <Sidebar />
      <div className="page-wrapper cardhead">
        <div className="content container-fluid">
          <div
            className="page-header"
            style={{
              position: "fixed",
              top: "2px",
              zIndex: "999",
            }}
          >
            <div className="row breadcrumb-position">
              {/* <h3 className="page-title">Customer Balance Detail</h3> */}
              <ul className="breadcrumb">
                <li className="breadcrumb-item" style={{ marginLeft: "12px" }}>
                  <Link to="/dashboard">Dashboard</Link>
                </li>
                <li className="breadcrumb-item">
                  <Link to="/reports">Report</Link>
                </li>
                <li className="breadcrumb-item active">
                  Inventory Detailed Report
                </li>
              </ul>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Report Period
              </label>
              <div className="row">
                <div className="col-md-12 z-3">
                  <Select
                    styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                    options={reportdropdown}
                    // defaultValue={selectReport}
                    backspaceRemovesValue={false}
                    controlShouldRenderValue={true}
                    hideSelectedOptions={true}
                    // isClearable={true}
                    name="Reportperiod"
                    id="Reportperiod"
                    value={reportdropdown.find((e) => e.value === selectReport)}
                    onChange={(event) => {
                      handleDropdownChange(event);
                    }}
                    className="custom-search-select"
                  ></Select>
                </div>
              </div>
            </div>
            {selectReport !== 1 && (
              <div className="col-sm-3">
                {/* <div className="row"> */}
                <ReportDate
                  callback={callback}
                  selectReport={selectReport}
                  showhidecomponent={
                    selectReport == 2 ||
                    selectReport == 3 ||
                    selectReport == 4 ||
                    selectReport == 5 ||
                    selectReport == 6 ||
                    selectReport == 7 ||
                    selectReport == 8 ||
                    selectReport == 9 ||
                    selectReport == 10 ||
                    selectReport == 11 ||
                    selectReport == 12 ||
                    selectReport == 13 ||
                    selectReport == 14 ||
                    selectReport == 15 ||
                    selectReport == 16 ||
                    selectReport == 17 ||
                    selectReport == 18 ||
                    selectReport == 19 ||
                    selectReport == 20 ||
                    selectReport == 21 ||
                    selectReport == 22 ||
                    selectReport == 23 ||
                    selectReport == 24 ||
                    selectReport == 25 ||
                    selectReport == 26 ||
                    selectReport == 27 ||
                    selectReport == 28 ||
                    selectReport == 29 ||
                    selectReport == 30 ||
                    selectReport == 31
                      ? true
                      : false
                  }
                />
                {/* </div> */}
              </div>
            )}
            <div className="col-sm-3">
              <label className="col-form-label col-md-5 form-label p-lg-medium">
                Locations
              </label>
              <div className="col-md-12 z-3">
                <Select
                  styles={CUSTOM_SELECT_DROPDOWN_STYLE}
                  options={locationDropdownOption}
                  backspaceRemovesValue={false}
                  controlShouldRenderValue={true}
                  hideSelectedOptions={true}
                  // isClearable={true}
                  name="location"
                  id="location"
                  value={locationDropdownOption.find(
                    (e) => e.value === selectedlocationid
                  )}
                  onChange={(event) => {
                    handleLocationDropdownChange(event);
                  }}
                  className="custom-search-select"
                ></Select>
              </div>
            </div>
            <div className="col-sm-3">
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                Show manual Adjustments Only
              </label>
              <div className="row">
                <div className="col-md-12 z-3 mt-1">
                  <input
                    type="checkbox"
                    id="AllowResell"
                    name="AllowResell"
                    // value="true"
                    // checked={AllowResell}
                    style={{
                      height: "20px",
                      width: "20px",
                    }}
                    onChange={(e) => {
                      handleCheckBoxChnage(e);
                    }}
                  />
                </div>
              </div>
            </div>

            <div className="col">
              {/* align-self-sm-end */}
              <label className="col-form-label col-md-12 form-label p-lg-medium">
                {""}
              </label>

              <button
                type="submit"
                className="btn btn-primary"
                // style={{ marginLeft: "auto" }}
                onClick={() => apicall()}
              >
                Run Report
              </button>
            </div>
          </div>
          {responseData.length > 0 && (
            <>
              <div
                className="row"
                style={{
                  display: "grid",
                  gap: "1rem",
                  gridTemplateColumns: "repeat(auto-fit, minmax(250px, 1fr))",
                }}
              >
                <div className="cards col-md-3">
                  <div className="dash-widget" style={dashStyle}>
                    <div className="dash-widgetimg"></div>
                    <div className="dash-widgetcontent">
                      <p className="p-20">
                        {totalData}
                        {/* {CurrencySymbols(
                      Number(totalData),
                      { CurrencySymbol },
                      FractionDigits
                    )} */}
                      </p>
                      <div className="d-flex">
                        <p className="p-medium">Average Quantity Sold </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {/* Receipt */}

              <div className="card mt-3">
                <div className="card-body">
                  <div className="container">
                    <div className="col-md-12 text-center " id="header">
                      <h6 class="p">SonarPos</h6>
                      <p className="fw-bold p-regular">
                        Inventory Detailed Report
                      </p>
                      <div className="row mb-2">
                        <p>
                          Date:{" "}
                          {startdate === "" && enddate === ""
                            ? "All Data"
                            : moment(startdate).format(
                                `${dateFormate.toUpperCase()}`
                              ) +
                              " - " +
                              moment(enddate).format(
                                `${dateFormate.toUpperCase()}`
                              )}
                        </p>
                      </div>
                    </div>
                  </div>
                  <hr />
                  <div className="table-responsive">
                    <div className="table mt-3"></div>
                    <div>
                      <CommonMatrialReactTable
                        MainHeading="Sonar POS"
                        ReportHeading="Inventory Detailed Report"
                        columns={columns}
                        data={responseData}
                        startdate={startdate}
                        enddate={enddate}
                        columnGrouping={[]}
                        columnsVisibility={{}}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default InventoryDetailedReport;
